export enum AccountVariableType {
  IT_CONTACT = 'it_contact',
}

export type ItContactValue = {
  name: string;
  email?: string | null;
  phone?: string | null;
  openingHours?: string | null;
  other?: string | null;
};

export type AccountVariableValue = ItContactValue;

export type AccountVariable = {
  id: string;
  type: AccountVariableType;
  value: AccountVariableValue;
  created: string;
  updated?: string | null;
};

export type SaveAccountVariableRequest = ItContactValue;
